/* ----------------------------------------------------------------------------
 * asyncGuard — a pure, node-testable staleness check for voice async results.
 *
 * PROBLEM (owner-reported, 2026-07-19): pressing Stop while Listening left Aura
 * stuck — a late STT `onFinal` still called think(), and think() could dispatch
 * SPEAK (valid from 'idle'), moving Aura back to Thinking/Speaking AFTER the
 * user had stopped. The controller stamps every new turn (and every stop) with a
 * monotonically increasing EPOCH; any async continuation captures the epoch it
 * started under and BAILS if the epoch has since moved.
 *
 * PURE: no state, no I/O — trivially unit-testable and reused at every async
 * seam (STT onFinal -> think, and before think dispatches SPEAK/speakSegments).
 * -------------------------------------------------------------------------- */

/**
 * True when the epoch captured at the start of an async operation no longer
 * matches the current epoch — i.e. a new turn or a Stop happened meanwhile, so
 * this result is stale and must NOT mutate voice state.
 */
export function isStale(startedEpoch: number, currentEpoch: number): boolean {
  return startedEpoch !== currentEpoch;
}

/** Convenience inverse — the captured epoch is still the live turn. */
export function isCurrent(startedEpoch: number, currentEpoch: number): boolean {
  return startedEpoch === currentEpoch;
}
